const mutations = {
  SET (state, response) {
    let messages = []
    response.data.forEach(message => {
      message.messageId = message.uuid
      message.edit = false
      const translations = {}
      message.translations.forEach(translation => {
        translations[translation.language] = translation.translation
      })
      message.translations = translations
      messages.push(message)
    })

    state.translations = messages
    state.currentPage = parseInt(response.headers['x-pagination-current-page'])
    state.totalPageCount = parseInt(response.headers['x-pagination-page-count'])
    state.totalCount = parseInt(response.headers['x-pagination-total-count'])
  },

  REMOVE (state, id) {
    state.translations = state.translations.filter(translation => translation.messageId !== id)
  },

  REMOVE_NEW (state, localId) {
    state.newTranslations = state.newTranslations.filter(translation => translation.localId !== localId)
  },

  ADD_NEW (state) {
    const previous = state.newTranslations[state.newTranslations.length - 1]
    let newIndex = 0
    if (previous) {
      newIndex = previous.localId + 1
    }
    const data = {
      message: '',
      translation: '',
      context: '',
      localId: newIndex
    }
    state.newTranslations.push(data)
  },

  ADD (state, data) {
    state.translations.push(data)
  },

  ALLOW_EDIT (state, translation) {
    translation.edit = true
  },

  DISABLE_EDIT (state, translation) {
    translation.edit = false
  }
}

export default mutations
